export const padFips = (fipsCode: string): string => {
  return fipsCode.padStart(5, '0');
};
